import { render, staticRenderFns } from "./global-navigation.vue?vue&type=template&id=6473d060&scoped=true&"
import script from "./global-navigation.vue?vue&type=script&lang=js&"
export * from "./global-navigation.vue?vue&type=script&lang=js&"
import style0 from "./global-navigation.vue?vue&type=style&index=0&id=6473d060&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6473d060",
  null
  
)

export default component.exports